module.exports = __webpack_public_path__ + "12e37c67e83f18f4adb44afd54baafec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/connectionBetweenPublicTransport.png
// module id = 3233
// module chunks = 0